import { B2B_COPILOT_PLAN_USER_PROMPT } from './b2bCopilotPlanDemoContent.js'

/** @param {string} trimmed */
export function isB2bCopilotPlanDemoPrompt(trimmed) {
  return trimmed === B2B_COPILOT_PLAN_USER_PROMPT
}
